import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PesquisaSatisfacaoService } from '@app/services';
import { environment } from '@environments/environment';
import {AppComponent} from '../app.component';

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
})
export class AppLoginComponent implements OnInit {

    linkPortal: string = environment.urlPortalDoAluno;


    constructor(
                  public app: AppComponent,
                  private router: Router,
                  private servico: PesquisaSatisfacaoService) {}



    ngOnInit(): void {
        window.open(this.linkPortal, '_self');
    }
}
